module.exports = __webpack_public_path__ + "img/10_49.f66c2788.png";